module.exports = __webpack_public_path__ + "img/select-file.360b3806.svg";